(function () {
    'use strict';

    angular.module('app.roles', [
        // Angular modules 
        'ngRoute'

        // Custom modules 

        // 3rd Party Modules
        
    ]);
})();